import React, {forwardRef, useId} from "react";
import classNames from "classnames";

import {Text} from "@pg-design/text-module";

import {ToggleButtonProps} from "../types/IToggleButtonProps";

import * as style from "./ToggleButton.module.css";

export const ToggleButton = forwardRef<HTMLDivElement & HTMLAnchorElement, ToggleButtonProps>((props, ref) => {
    const {children, className, dataTestId, href, as: Element = "div", onClick, icon} = props;

    const cn = classNames(className, style.buttonStyle, {[style.active]: props.isActive});

    const labelId = useId();

    return (
        <Element aria-labelledby={labelId} ref={ref} className={cn} onClick={() => onClick?.()} data-testid={dataTestId} href={href}>
            {icon}
            <label id={labelId}>
                <Text variant="info_txt_1">{children}</Text>
            </label>
        </Element>
    );
});
import React, {forwardRef, useId} from "react";
import classNames from "classnames";

import {Text} from "@pg-design/text-module";

import {ToggleButtonProps} from "../types/IToggleButtonProps";

import * as style from "./ToggleButton.module.css";

export const ToggleButton = forwardRef<HTMLDivElement & HTMLAnchorElement, ToggleButtonProps>((props, ref) => {
    const {children, className, dataTestId, href, as: Element = "div", onClick, icon} = props;

    const cn = classNames(className, style.buttonStyle, {[style.active]: props.isActive});

    const labelId = useId();

    return (
        <Element aria-labelledby={labelId} ref={ref} className={cn} onClick={() => onClick?.()} data-testid={dataTestId} href={href}>
            {icon}
            <label id={labelId}>
                <Text variant="info_txt_1">{children}</Text>
            </label>
        </Element>
    );
});
